import { createStore } from "vuex";

const store = createStore({
  state() {
    return {
      server: "https://jamback.stat.tj",
      // server:"https://localhost:44378",
      // server:"http://localhost:4493",

      version: 43,

      login: false,
      tername: "",
      count: 0,
      books: [],
      households: [],
      members: [],
      data: [],
      ter: [],
      class: [],
      atoken: "",
      rtoken: "",

      logins: [
        "admin2",
        "pakhtaobod",
        "navobod",
        "dusti",
        "jfarkhor",
        "childukhtaron",
        "50sol",
        "dangara",
        "chagam",
        "miskinobod",
        "jfayzob",
        "kholmatov",
        "istiqlol",
        "javkandak",
      ],
      showmenu: true,
      iduser: 0,
      terid: 0,
      book: "",
      household: {},
      member: {},

      mid: 0,
      spravka: {},
      danger: "Диққат",
      updatemessage:
        "Версияи барномаи Шумо куҳна аст. Лутфан тугмаи ОК-ро барои азнавкунии (обновления) барнома пахш намоед",
      memo1:
        "Дода шуд дар ин бора, ки шаҳрванд {0} соли таваллудаш {1} буда, дар деҳаи {2} дар хоҷагии №{3} ба қайд гирифта шуда ва дар ҳамин суроға зиндагонӣ менамояд.",
      memo2:
        "Дода шуд дар ин бора, ки шаҳрванд {0} соли таваллудаш {1} буда, дар деҳаи {2} дар хоҷагии №{3} ба қайд гирифта шуда ва дар ҳамин суроға зиндагонӣ менамояд. Дар суроғаи зерин инчунин шахсони зерин дар қайд мебошанд.",
    };
  },
  mutations: {
    increment(state) {
      state.count++;
    },
    clearTokens(state) {
      state.atoken = null;
      state.rtoken = null;
      state.login = false;

      state.ter = "";

      state.tername = "";
      state.count = 0;
      state.books = [];
      state.households = [];
      state.members = [];
      state.data = [];
      state.ter = [];

      state.terid = 0;
      state.book = "";
      state.household = {};
      state.member = {};

      state.mid = 0;
      state.spravka = {};
    },
  },
  actions: {
    logout({ commit }) {
      commit("clearTokens");
    },
  },
});

export default store;
